// Virksomhedsoplysninger
export const companyInfo = {
  name: "Johanne Eis",
  cvr: "40596453",
  phone: "42 43 90 52",
  email: "eis.johanne@gmail.com",
  address: "Sprogøvej 7, 5610 Assens",
  facebookGroup: "https://www.facebook.com/groups/1851775828498014/",
  facebookPage: "https://www.facebook.com/johanne.eis",
  instagram: "https://www.instagram.com/johanne_eis/"
};

// Metadata for alle sider
export const pageMetadata = {
  home: {
    title: "Johanne Eis – Spirituel livsskabelse & 1:1 sessioner",
    description: "Opdag spirituel livsskabelse med Johanne Eis – 1:1 sessioner, lydhealing, cacao ceremonier & magiske redskaber til dit hjerte og din udvikling.",
    ogImage: ""
  },
  events: {
    title: "Events & Cirkler - Johanne Eis",
    description: "Deltag i nærværende, individuelle og meningsfulde events, ceremonier og cirkelforløb hos Johanne Eis. Se kommende og afholdte events her.",
    ogImage: "https://assets.auxodev.dk/assets/9c094138-0bed-486b-b914-79750263377d/25-johanne-eis-1920x900-7n-1.webp"
  },
  sessions: {
    title: "Individuelle 1:1 Sessioner - Johanne Eis",
    description: "Individuelle sessioner – Skab liv i livet. I en 1:1 session stiller jeg mig til rådighed for det, du har på hjertet, som du ønsker transformeret.",
    ogImage: "https://assets.auxodev.dk/assets/9c094138-0bed-486b-b914-79750263377d/25-johanne-eis-350x380-4.webp"
  },
  about: {
    title: "Om Johanne Eis - Johanne Eis",
    description: "Min største lektie her i livet har været i træde ind i mit lys og lade mig være centrum for mit liv. Læs om min baggrund og min tilgang.",
    ogImage: "https://assets.auxodev.dk/assets/9c094138-0bed-486b-b914-79750263377d/25-johanne-eis-620x440-1-1.webp"
  },
  contact: {
    title: "Kontakt Johanne Eis - Johanne Eis",
    description: "Når du er klar – er jeg her. Du er velkommen til at kontakte mig, hvis du har spørgsmål til sessioner, events, eller magiske redskaber.",
    ogImage: "https://assets.auxodev.dk/assets/9c094138-0bed-486b-b914-79750263377d/25-johanne-eis-1080x1920-5-1.webp"
  }
};

// Udtalelser (Testimonials)
export const testimonials = [
  {
    name: "IngerMaria",
    text: "Tak for forløbet 🙏🙏 Det har flyttet søjler, jeg føler virkelig at jeg er flyttet udefra min krop, og nu er kommet hjem, helt ind i kroppen.",
    avatar: "https://assets.auxodev.dk/assets/9c094138-0bed-486b-b914-79750263377d/cropped-johanne-eis-favicon.webp"
  },
  {
    name: "IngerMaria",
    text: "Den uforløste moderkærlighed der har ligget så smertefuldt dybt var god at imødekomme og give plads. Det har været en ensom smerte. Der blev arbejdet intenst mens jeg bare kunne iagttage og lade det falde på plads. Jeg blev rank, jordforbundet og meget tilstede. Oplevede at min evne til at kommunikere med min krop og skabe forbindelse til universet blev genetableret. Har helt ro i kroppen og den opleves meget levende. I live❤️",
    avatar: "https://assets.auxodev.dk/assets/9c094138-0bed-486b-b914-79750263377d/cropped-johanne-eis-favicon.webp"
  },
  {
    name: "Allis",
    text: "Forløbet har betydet SÅ meget for mig. 🌸🌼 Min selvtillid er kommet tilbage og jeg har nemmere ved at sige fra til noget som ikke nærer mig 🥰 Har fået en tættere kontakt til “mig selv“. 1000 tak for 3 dage fyldt med kærlighed, nærvær & omsorg .. Johanne har en fantastisk forståelse for alle 🤗❤️",
    avatar: "https://assets.auxodev.dk/assets/9c094138-0bed-486b-b914-79750263377d/cropped-johanne-eis-favicon.webp"
  },
  {
    name: "Jette",
    text: "Jeg har den vildeste oplevelse efter et forløb i forhold til min egen fødsel og min datters fødsel der rækker dybt ind i slægtens energi i forhold til kvinders undertrykkelse. Jeg har oplevelsen af at være trådt ud af et fængsel og være FRI til at forme mit liv uden tidligere tiders begrænsninger. Johanne er guidet og ført, – forberedt et andet sted fra så rummet er sat fra man kommer ind af døren. De varmeste anbefalinger herfra.",
    avatar: "https://assets.auxodev.dk/assets/9c094138-0bed-486b-b914-79750263377d/cropped-johanne-eis-favicon.webp"
  },
  {
    name: "Marie",
    text: "Johanne har evnen til at gribe nuet i alt der kommer frem. Hver en lille sansning, reaktion og følelse. Den lille stemme og de dybeste hemmeligheder bliver bragt frem og hilst velkommen. Johanne kan som seer på smukkeste vis sammenkøre episoder i livet, med tidligere liv, karmiske relationer og slægtsenergi og nå derind hvor ord ikke kan nå. Johanne forløser via stemmes lyd og trommen.",
    avatar: "https://assets.auxodev.dk/assets/9c094138-0bed-486b-b914-79750263377d/cropped-johanne-eis-favicon.webp"
  },
  {
    name: "Kirsten",
    text: "Så dejligt og smukt at være i dette kærlige rum som fylder mig helt op ❤️🙏 Tak, Johanne for denne smukke oplevelse",
    avatar: "https://assets.auxodev.dk/assets/9c094138-0bed-486b-b914-79750263377d/cropped-johanne-eis-favicon.webp"
  },
  {
    name: "Lykke",
    text: "Tak for en dejlig rosecermoni.🥰 Jeg var meget træt da jeg kom. Jeg fik meget kærlighed og tryghed af feltet. Jeg er så taknemmelig over min indianer familie, og især stammens medicinmand/ høvding? Min indianer med hvid klædedragt.❤ Tak til dig Johanne",
    avatar: "https://assets.auxodev.dk/assets/9c094138-0bed-486b-b914-79750263377d/cropped-johanne-eis-favicon.webp"
  },
  {
    name: "Marlene",
    text: "Jeg mærkede dyb ro – som om jeg blev ført dybere ind i min essens – uden helt at opdage at det var det som skete",
    avatar: "https://assets.auxodev.dk/assets/9c094138-0bed-486b-b914-79750263377d/cropped-johanne-eis-favicon.webp"
  },
  {
    name: "Lene",
    text: "Taak 💖💖💖grounding og stemmen blev fyldt med energi",
    avatar: "https://assets.auxodev.dk/assets/9c094138-0bed-486b-b914-79750263377d/cropped-johanne-eis-favicon.webp"
  },
  {
    name: "Sonja",
    text: "Der er en dejlig ro og mærker det så dejligt min krop gik med ❤️",
    avatar: "https://assets.auxodev.dk/assets/9c094138-0bed-486b-b914-79750263377d/cropped-johanne-eis-favicon.webp"
  },
  {
    name: "Tove",
    text: "Bølgede gennem hele kroppen sang og lyde kom frem af sig selv….stor indre ro hvor jeg landede med ren følelse af tilfredshed. Af hjertet tak❤️",
    avatar: "https://assets.auxodev.dk/assets/9c094138-0bed-486b-b914-79750263377d/cropped-johanne-eis-favicon.webp"
  }
];

// Individuelle sessioner pakker
export const sessionPackages = [
  {
    title: "1:1 session – lille",
    duration: "60 min.",
    price: "1500,-",
    description: "I sessionen er det vigtigt du har stillet skarpt på et aspekt, som du ønsker at træde ind i din skabende kraft i forhold til, så du er afklaret om hvad jeg skal hjælpe dig med at åbne til. Hvis du ikke ved, hvad du skal åbne til, kan det være det som er fokus.",
    ctaText: "Book lille session"
  },
  {
    title: "1:1 session – stor",
    duration: "120 min.",
    price: "2580,-",
    description: "I den store session er der plads til at flere emner kan blive transformeret. Ting hænger ofte hænger sammen og du får et bredere perspektiv til at træde rent frem i din skabende kraft. Her er pladsen til dialogen som ofte får de sidste skridt til at falde på plads.",
    ctaText: "Book stor session"
  },
  {
    title: "Hurtig støtte til din rejse i livet lige nu",
    duration: "Messenger Lydfiler",
    price: "380,-",
    description: "Du beskriver på skrift eller i tale via Messenger, hvad du står i lige nu og meget gerne hvor du vil hen. Jeg svarer via lydfil. Når jeg tænder mikrofonen går kanaliseringen i gang og du modtager, det som er til dig lige nu og her. Du giver en kort tilbagemelding på det du har modtaget. Herefter får du en lille lydfil mere. Lydfilerne er korte men til gengæld meget præcise til det du står i.",
    ctaText: "Kontakt for bestilling"
  }
];

// Magiske redskaber
export const magicTools = {
  intro: {
    title: "Magiske redskaber – Intention i form",
    text: "Alle Magiske Redskaber der skabes fra min hånd, kommer med budskaber. Der er en intelligens i feltet, der skaber redskaberne, som taler og lander med de beskeder, som vil igennem. De skaber Magisk Transformation SÅ meget større end ord. De tryller Magien ind på forunderligste vis. Som bliver du hvisket i øret, så du kan høre det klart -og andre gange helt lydløst. De er alle kodet til at arbejde til dit højeste bedste og til alles højeste bedste. De renser energier omkring sig, så lyset kan tænde lys. I en indvielse kobles du til det redskab du køber og du mærker forbindelsen imellem dig og dit redskab som om dit redskab taler fra dit hjerte. Jeg tilbyder en indvielse enten online eller ved fysisk fremmøde ved mit medicinhjul. Jeg har nogle gange Redskaber til salg, fordi de synger at de vil ud og lege et nyt sted, men de fleste gange bliver de lavet på bestilling."
  },
  drums: {
    title: "Shaman Trommer – De taler og skaber magiske rejser",
    text: "Trommerne er mere end blot en tromme, nærmere et levende væsen, der er skabt til at tjene Dit Højeste bedste – Det Højeste bedste i alt, hvad du er og alt som er. Den er skabt til at ny tids energi kan lande ind helt her ned på jorden. Trommen er perfekt til at kalde dig helt hjem i din kraft – når DIN indvielse sker, forbindes du personligt til din tromme, så trommen arbejder for dig, med dig og til alt hvad der er omkring dig – Og din form og din kanal kan gå i samklang med din Tromme. Trommen bærer en stærk højt vibrerende feminin energi og samtidig en kærlig dyb Groundende energi. Den arbejder direkte med Moder Jords hjerte, Medicinhjulet og Sacred Rose feltet. Sacred Rose er mit Shaman navn og det repræsenterer et helt specielt felt af kærlig energi som gerne vil bredes ud i verden. Når du bruger Trommen, så dannes der en Rosenhaven omkring dig og den kan du lade blomstre videre ud, på den måde du er kaldet til. Når vi arbejder med Trommen giver vi det til Trommen og det kommer tilbage i ny form med den visdom der tjener dig.",
    types: [
      {
        title: "Celebration of life",
        desc: "Råskindstromme af Dåhjort",
        image: "https://assets.auxodev.dk/assets/9c094138-0bed-486b-b914-79750263377d/25-johanne-eis-350x380-6-1.webp"
      },
      {
        title: "Livets leg",
        desc: "Samlingstromme til leg og lethed",
        image: "https://assets.auxodev.dk/assets/9c094138-0bed-486b-b914-79750263377d/25-johanne-eis-350x380-7-1.webp"
      },
      {
        title: "The Magic being Flourish",
        desc: "Væk frekvensen af din blomstring",
        image: "https://assets.auxodev.dk/assets/9c094138-0bed-486b-b914-79750263377d/25-johanne-eis-350x380-8-1.webp"
      }
    ]
  },
  drumsticks: {
    title: "Personlig Trommestik med budskaber",
    text: "Jeg laver personlige Trommestiks til din tromme på bestilling. Når jeg skaber dem taler de til mig. Der lander meget præcise beskeder ind om navnet den ønsker at bære og nogle temaer omkring navnet. Under skabelsen kan jeg blive guidet til at sende små lydbeskeder til dig om processen. Materialer, form og farve bliver mig vist og i selve forarbejdningen lander der ligeledes beskeder ind. Når den når ud til den nye ejer så laver vi en indvielse så du bliver forbundet med den i hjertet. Mange mærker ofte en øjeblikkelig forbindelse når de tager den i hånden. Dette øjeblik er ofte ret magisk at se på – da der sker en forbindelsen som ofte er svær at beskrive med ord. Feltet den arbejder fra, er det felt der er beskrevet under Trommerne og så alt det som ord ikke rækker til.",
    price: "1280,-",
    comboPrice: "680,- (købt sammen med tromme)"
  },
  rattles: {
    title: "Magiske Rasler – Magiske lydvibrationer og beskeder",
    text: "Raslerne er intet mindre end blot magiske – under fremstillingen får jeg meget tydeligt besked om hvordan de vil arbejde. De tryller og skaber magi på den vildeste måde og de er lette at have med sig.",
    price: "1380,-",
    items: [
      {
        title: "Guld og Grønne skove",
        desc: "Når den rasler skabes en helt vild Jordforbindelse – vores livstræ går helt ned i Moder Jords hjerte og vores livstræ bliver gyldent af guld og kronen lyser smukt grønt – og den giver adgang til at vores trækrone kan gå helt op i himlen",
        image: "https://assets.auxodev.dk/assets/9c094138-0bed-486b-b914-79750263377d/25-johanne-eis-350x380-9-1.webp"
      },
      {
        title: "Heart Voice",
        desc: "Når den rasler åbnes hjertet til din magiske hjerteforbindelse. Energi bølger fra hjertet og ud i skønne farver, og hjertet åbner til sin egen melodi. Energien strømmer ud i hele dig og du bliver dit hjertes sande vibration.",
        image: "https://assets.auxodev.dk/assets/9c094138-0bed-486b-b914-79750263377d/25-johanne-eis-350x380-10-1.webp"
      },
      {
        title: "Livet i sin skønhed, renhed og lethed som i leg.",
        desc: "Den renser al tunghed væk og dybt indefra tændes du til livet i lethed",
        image: "https://assets.auxodev.dk/assets/9c094138-0bed-486b-b914-79750263377d/25-johanne-eis-350x380-11-1.webp"
      }
    ]
  }
};
